import React, { useEffect, useState } from "react";
import RoleDetails from "./RoleDetails";
import SendInvite from "./SendInvite";
import UserList from "./UserList";
import AssignPermissions from "./AssignPermissions";
import { getRoles } from "../../../services/settings";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/AuthContextProvider";
import Toggle from "../../../components/Toggle";
import LoadingScreen from "../../../components/LoadingScreen";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Permission = () => {
  const [permission, setPermission] = useState(true);
  const [roleDetails, setRoleDetails] = useState(false);
  const [sendInvite, setSendInvite] = useState(false);
  const [userList, setUserList] = useState(false);
  const [assignPermissions, setAssignPermissions] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [secondRoleId, setSecondRoleId] = useState("");
  const [roles, setRoles] = useState([]);
  const { user, globalProfile } = useAuth();
  const permissions = user.permissionList;
  const [loading, setLoading] = useState(false);
  const [newRoleName, setNewRoleName] = useState("");
  const [newRoleDesp, setNewRoleDesp] = useState("");
  const navigate = useNavigate();

  const handleCancel = () => {
    setPermission(true);
    setRoleDetails(false);
    setSendInvite(false);
    setUserList(false);
    setAssignPermissions(false);
    setRoleId("");
    setSecondRoleId("");
    setNewRoleName("");
    setNewRoleDesp("");
  };

  const handlePermission = () => {
    setPermission(false);
    setRoleDetails(true);
  };

  const handleRole = (name, description) => {
    setNewRoleName(name);
    setNewRoleDesp(description);
    setRoleDetails(false);
    setAssignPermissions(true);
  };

  const handleAssign = () => {
    setAssignPermissions(false);
    setSendInvite(true);
    fetchRoles();
  };

  const handleInvite = () => {
    setSendInvite(false);
    setUserList(true);
  };

  const handleInviteUser = () => {
    setPermission(false);
    setSendInvite(true);
  };

  const handleViewPermissionOnInvite = (id) => {
    setSendInvite(false);
    setAssignPermissions(true);
    setSecondRoleId(id);
    setRoleId(id);
  };

  const handleViewPermissionOnUserList = (id) => {
    setUserList(false);
    setAssignPermissions(true);
    setSecondRoleId(id);
  };

  const handleViewRolesList = (id) => {
    setPermission(false);
    setAssignPermissions(true);
    setSecondRoleId(id);
    setRoleId(id);
  };

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const res = await getRoles();
      setRoles(res.data || []);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [globalProfile]);

  if (loading) {
    return <LoadingScreen title="Settings - Permission" />;
  }

  return (
    <>
      {permission && (
        <div>
          <div className="flex sm:flex-row flex-col items-start md:items-center justify-between">
            <h1 className="text-navy-blue text-2xl font-bold">
              Settings - Permission
            </h1>
            <Toggle />
          </div>

          {roles.length === 0 ? (
            <section className="md:h-[924px] bg-white mt-8 rounded-[10px] md:p-[3rem]">
              <div className="text-4xl font-semibold w-[515px]">
                You have no user permission created
              </div>

              <button
                className="bg-primary mt-12 flex items-center justify-center text-white w-[272px] h-[42px] rounded-[10px]"
                onClick={handlePermission}
              >
                + Add User Permission
              </button>
            </section>
          ) : (
            <div className="md:h-[924px] rounded-[10px] md:p-[3rem]">
              <section className="flex justify-around sm:justify-between mb-5">
                <h1 className="font-medium text-3xl">My Roles</h1>
                <div className="flex items-center gap-2 pr-2 md:pr-0">
                  <button
                    className={`bg-primary h-[40px] p-2 text-white rounded-md ${
                      permissions.includes("Create Role") ? "block" : "hidden"
                    }`}
                    type="button"
                    onClick={handlePermission}
                  >
                    Create New Role
                  </button>

                  <button
                    className="bg-blue-400 h-[40px] p-2 text-white rounded-md"
                    type="button"
                    onClick={handleInviteUser}
                  >
                    Invite New User
                  </button>
                </div>
              </section>

              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <DataTable
                  value={roles}
                  emptyMessage="No roles found."
                  className="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column
                    field="name"
                    header="Role Name"
                    body={(row) => (
                      <div className="py-2 font-medium">{row.name}</div>
                    )}
                  />
                  <Column
                    field="description"
                    header="Role Description"
                    body={(row) => (
                      <div className="py-2 text-gray-600">{row.description}</div>
                    )}
                  />
                  <Column
                    header="Edit"
                    body={(row) => (
                      <button
                        type="button"
                        className="py-2 cursor-pointer text-primary hover:underline font-medium"
                        onClick={() => handleViewRolesList(row.id)}
                      >
                        Edit permission
                      </button>
                    )}
                  />
                </DataTable>
              </div>
            </div>
          )}
        </div>
      )}
      {roleDetails && (
        <RoleDetails
          handleRole={handleRole}
          handleCancel={handleCancel}
          setRoleId={setRoleId}
        />
      )}
      {assignPermissions && (
        <AssignPermissions
          handleAssign={handleAssign}
          handleCancel={handleCancel}
          roleId={roleId}
          secondRoleId={secondRoleId}
          newRoleName={newRoleName}
          newRoleDesp={newRoleDesp}
        />
      )}
      {sendInvite && (
        <SendInvite
          handleInvite={handleInvite}
          handleCancel={handleCancel}
          handlePermissionInvite={handleViewPermissionOnInvite}
        />
      )}
      {userList && (
        <UserList
          handleCancel={handleCancel}
          handleViewPermission={handleViewPermissionOnUserList}
        />
      )}
    </>
  );
};

export default Permission;
